import es from '@locales/es.json'
import en from '@locales/en.json'
import { setApiLocale } from '@/api/api'
import moment from 'moment'
import 'moment/locale/es'

const catalogs = {
  es,
  en,
}

const SUPPORTED = ['es', 'en']
const STORAGE_KEY = 'sales_locale'

export function normalizeLang(value) {
  if (!value) return 'es'
  const code = String(value).trim().toLowerCase().replace('_', '-').split('-')[0]
  return SUPPORTED.indexOf(code) >= 0 ? code : 'es'
}

export function translate(message, lang, params) {
  if (message === null || message === undefined) return message
  const text = String(message)
  if (!text) return text
  const catalog = catalogs[normalizeLang(lang)] || {}
  let out = Object.prototype.hasOwnProperty.call(catalog, text) ? catalog[text] : text
  if (params !== undefined && params !== null) {
    if (Array.isArray(params)) {
      let i = 0
      out = out.replace(/%(?:\.\d+)?[sdif]/g, () => {
        const v = params[i++]
        return v === undefined ? '' : String(v)
      })
    } else if (typeof params === 'object') {
      out = out.replace(/\{(\w+)\}/g, (_, key) => (
        params[key] !== undefined ? String(params[key]) : `{${key}}`
      ))
    } else {
      out = out.replace(/%(?:\.\d+)?[sdif]/, String(params))
    }
  }
  return out
}

export function getStoredLocale() {
  try {
    return normalizeLang(localStorage.getItem(STORAGE_KEY) || 'es')
  } catch (e) {
    return 'es'
  }
}

export function persistLocale(lang) {
  const normalized = normalizeLang(lang)
  try {
    localStorage.setItem(STORAGE_KEY, normalized)
  } catch (e) { /* ignore */ }
  setApiLocale(normalized)
  moment.locale(normalized)
  return normalized
}

export default {
  install(Vue, options = {}) {
    const store = options.store
    const initial = getStoredLocale()
    persistLocale(initial)
    if (store) {
      store.commit('locale', initial)
    }

    Vue.prototype.$t = function $t(message, params) {
      const lang = (this && this.$store && this.$store.state && this.$store.state.locale) || getStoredLocale()
      return translate(message, lang, params)
    }

    Vue.prototype.$locale = function $locale() {
      return (this && this.$store && this.$store.state && this.$store.state.locale) || getStoredLocale()
    }

    Vue.prototype.$setLocale = function $setLocale(lang) {
      const normalized = persistLocale(lang)
      if (store) store.commit('locale', normalized)
      return normalized
    }

    Vue.filter('t', function (message, params) {
      const lang = (store && store.state && store.state.locale) || getStoredLocale()
      return translate(message, lang, params)
    })
  }
}
